<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    class="dialog"
    top="5vh"
    :close-on-click-modal="false"
    append-to-body
    width="900px"
    @close="closeDialog"
  >
    <div>
      <!--已经选择的员工-->
      <div v-if="multiple" class="p-10">
        <div>已{{ title }}：</div>
        <el-tag
          v-for="(item, index) in selectedList"
          :key="item.employeeId"
          closable
          class="m-t-10 m-r-10"
          @close="deleteEmployee(index)"
        >
          {{ item.name }}
        </el-tag>
      </div>

      <div class="flex col-top dialog-content">
        <!--      部门树形数据-->
        <div class="flex-left p-t-10 flex-shrink">
          <el-scrollbar>
            <el-tree
              class="tree"
              :data="departmentTree"
              :props="{ label: 'name', children: 'children' }"
              node-key="id"
              :expand-on-click-node="false"
              :check-on-click-node="true"
              :default-expand-all="true"
              highlight-current
              @node-click="selectDepartment"
            >
              <template v-slot="{ node }">
                <div class="text-ellipsis" :title="node.label">
                  {{ node.label }}
                </div>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>

        <!--      部门对应的员工列表-->
        <div class="m-l-20 flex-1 p-t-20">
          <el-form
            :model="filterForm"
            :inline="true"
            label-suffix="："
            size="small"
          >
            <el-form-item label="姓名">
              <el-input
                v-model.trim="filterForm.employeeName"
                placeholder="请输入姓名"
              />
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="handleSearch">
                查询
              </el-button>
              <el-button size="small" @click="handleReset">
                重置
              </el-button>
            </el-form-item>
          </el-form>

          <jczh-table-content
            ref="table"
            :data="tableList"
            :option="tableOption"
            table-id="employeeId"
            :selected="echoList"
            :selection="multiple"
            @row-click="selectRow"
            @selection-change="handleSelectionChange"
          />

          <pagination
            v-if="total > 0"
            ref="pagination"
            :total="total"
            :page.sync="page"
            :limit.sync="size"
            :page-sizes="[5]"
          />
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        取 消
      </el-button>
      <el-button type="primary" @click="confirm">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
// 组件
import Pagination from '@/components/common/Pagination'

// 后台接口
import { getDepartmentListApi, getEmployeeListApi } from '@/api/company'

// mixin
import listFilterMixin from '@/mixins/list-filter-mixin'

// 工具函数
import { transListToTree } from '@/utils/company'

export default {
  name: 'SelectEmployeeDialog',

  components: { Pagination },

  mixins: [listFilterMixin],

  props: {
    // 使用.sync
    showDialog: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    multiple: {
      type: Boolean,
      default: false
    },

    // 当multiple为true时，传入的回显数组
    echoList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      departmentTree: [],
      currentDepartmentId: '',

      filterForm: {
        employeeName: ''
      },

      tableList: [],
      tableOption: [
        { label: '姓名', prop: 'name' },
        { label: '手机号', prop: 'mobile' }
      ],
      total: 0,
      size: 5,
      selectedRow: null,
      selectedList: []
    }
  },

  computed: {
    visible: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit('update:showDialog', val)
      }
    }
  },

  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.getDepartmentTreeData()
      }
    },

    echoList: {
      handler(val) {
        this.selectedList = [...val]
        this.getIntersectionAndSelect()
      },
      immediate: true
    }
  },

  methods: {
    /**
     * Dialog关闭的回调函数
     */
    closeDialog() {
      this.page = 1
      this.$refs.table.clearSelection()
    },

    /**
     * 请求接口获取列表数据
     */
    getList() {
      this.epitaxy()

      getEmployeeListApi(
        Object.assign(
          {},
          {
            page: this.page,
            size: this.size,
            deptId: this.currentDepartmentId
          },
          this.filterForm
        )
      )
        .then(res => {
          const tempRecords = (res.data.records || []).map(value => {
            return Object.assign({}, value, { name: value.employeeName })
          })

          this.tableList = tempRecords
          this.total = res.data.total || 0

          this.$nextTick(() => {
            this.getIntersectionAndSelect()
          })
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /**
     * 获取部门树形数据，并添加公司改造
     */
    getDepartmentTreeData() {
      // 这里的type：1， 表示只要公司的部门列表；不传的情况下会返回一级子公司列表和部门列表
      getDepartmentListApi({ type: 1 })
        .then(res => {
          const temp = (res.data || []).map(value => {
            return {
              id: value.deptId,
              name: value?.deptInfo?.name,
              parentId: value?.parentInfo?.parentId || 0
            }
          })
          this.departmentTree = transListToTree(temp, 'id')
          this.currentDepartmentId = this.departmentTree[0]?.id || ''

          this.getList()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /**
     * 选中部门，查看当前部门的员工
     * @param data
     */
    selectDepartment(data) {
      this.currentDepartmentId = data.id
      this.getList()
    },

    /**
     * 点击表格选择行数据
     */
    selectRow(row) {
      this.selectedRow = row
    },

    /**
     * 表格多选
     */
    handleSelectionChange(selection) {
      this.selectedList = selection
    },

    /**
     * 删除已选择的员工
     */
    deleteEmployee(index) {
      this.selectedList.splice(index, 1)

      this.getIntersectionAndSelect()
    },

    // 根据传入的已选项集合，获取当前页数据与已选数据的交集，并选中
    getIntersectionAndSelect() {
      // 取交集
      const intersection = [...this.tableList].filter(x =>
        [...this.selectedList].some(y => y.employeeId === x.employeeId)
      )
      // 取差集
      const difference = [...this.tableList].filter(x =>
        [...intersection].every(y => y.employeeId !== x.employeeId)
      )

      if (!this.$refs.table) return

      if (this.selectedList.length > 0) {
        intersection.forEach(item => {
          this.$refs.table.toggleRowSelection(item, true)
        })
        difference.forEach(item => {
          this.$refs.table.toggleRowSelection(item, false)
        })
      } else {
        this.$refs.table.clearSelection()
      }
    },

    /**
     * 选定指定员工
     */
    confirm() {
      this.$emit(
        'confirm',
        this.multiple ? this.selectedList : this.selectedRow
      )
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
.dialog {
  overflow: hidden;

  ::v-deep .el-dialog__body {
    padding: 0px;

    .dialog-content {
      height: 433px;

      .flex-left {
        width: 240px;
        height: 100%;
        border-right: 1px solid $border-color;
      }
    }
  }
}

::v-deep .el-scrollbar {
  height: 100%;
  width: 100%;

  .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
}
</style>
